import eyeIcon from "../../../../assets/images/eye.svg";
import deleteIcon from "../../../../assets/images/trash.svg";

const CategoriesColumnDefDefaultFnC = (
  navigateCallback,
  onDeleteBUBtnClick,
) => [
  {
    accessorKey: "name",
    header: "Category Name",
  },
  {
    accessorKey: "isActive",
    // header: t('OrdersTableText.orderDate'),
    header: "Status",
    // cell: lastNameCellFn
  },
  {
    accessorKey: "isAllowedInSubscription",
    header: "Availability of Subscriptions",
  },
  {
    accessorKey: "image",
    header: "Cover Image",
  },
  {
    accessorKey: "action",
    header: "Action",
    cell: ({ row }) => {
      const categoryRowData = row.original;
      // console.log("categoryRowData=======>",categoryRowData)

      return (
        <div className="d-flex clays-sm">
          <button
            class="icon-clay"
            onClick={() => navigateCallback(categoryRowData._id, "view")}
          >
            <span class="inner-clay color-black">
              <img src={eyeIcon} alt="Edit" />
            </span>
          </button>
          <button
            className="icon-clay delete"
            onClick={() => onDeleteBUBtnClick(categoryRowData._id, "delete")}
          >
            <img src={deleteIcon} alt="Delete" />
          </button>
        </div>
      );
    },
  },
];
export { CategoriesColumnDefDefaultFnC };
